import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";

const Api = createApi({
  reducerPath: "chatApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_REVELATION_API_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).auth.user?.access_token;
      token && headers?.set("authorization", `Bearer ${token || ''}`);
      return headers;
    },
  }),
  tagTypes: [
    "GetTenant",
    "Chat",
    "Chats",
    "ChatMessages",
    "Profile",
    "UserFeatures",
    "ChatConfig",
    "ChatRequest",
    "ChatMyVisibility",
    "ChatPins",
    "GetUser"
  ],
  endpoints: (build) => ({
    getTenant: build.query<string, string>({
      query: (hostName) => "Account/TenantConfig/?tenantUrl=" + hostName,
      providesTags: ["GetTenant"],
    }),
  }),
});

export { Api };
